/* Sun Potion — upsell cards (PDP "Pairs well with", cart "Complete the ritual").
   Adds without leaving the page, then refreshes/opens the theme's quick cart through
   the theme's own event bus (window.emit, exposed by theme.js).
   Cart swap: add the set FIRST, then apply the line changes in data-sp-swap
   ("key:newQty|key:newQty"), so a failed add never removes anything.
   Line keys themselves contain ":" (variant:hash) — split each entry on the LAST colon.
   Cards are divs + type="button" (the quick cart drawer is a <form>; nested forms get dropped). */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.emit === 'function') {
          window.emit('cart:updated', { cart: cart });
          window.emit('quick-cart:updated');
          window.emit('quick-cart:open');
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-sp-upsell-button]');
    if (!button || typeof window.fetch !== 'function') return;
    var form = button.closest('[data-sp-upsell-card]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();

    if (button.disabled) return;
    button.disabled = true;
    form.classList.add('is-loading');

    var id = parseInt(form.getAttribute('data-variant-id'), 10);
    var swap = (form.getAttribute('data-sp-swap') || '').split('|').filter(Boolean);

    post('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function () {
        // decrement the single(s) one unit each, sequentially
        return swap.reduce(function (chain, entry) {
          var cut = entry.lastIndexOf(':');
          var key = entry.slice(0, cut);
          var qty = parseInt(entry.slice(cut + 1), 10);
          return chain.then(function () {
            return post('cart/change.js', { id: key, quantity: qty });
          });
        }, Promise.resolve());
      })
      .then(refreshCart)
      .then(function () {
        // full cart page (not the drawer): reload so line items, totals and the suggestion all agree
        if (document.body.classList.contains('template-cart') && !form.closest('.quick-cart')) {
          window.location.reload();
          return;
        }
        form.classList.remove('is-loading');
        form.classList.add('is-added');
        button.disabled = false;
      })
      .catch(function (err) {
        form.classList.remove('is-loading');
        button.disabled = false;
        refreshCart();
        if (typeof window.emit === 'function') window.emit('cart:error', null, { errorMessage: err.message });
        // eslint-disable-next-line no-console
        console.warn('[sp-upsells]', err.message);
      });
  });
  /* Collection / search / homepage cards (Carlo 9/28): a single-variant "Add to cart" goes through the theme's
     own quick-add (cart.addItemById → 'quick-cart:updated'), which only swaps the button for a quantity
     stepper. Open the cart drawer afterwards, like the PDP add. Multi-variant cards ("Choose options") are
     untouched. Capture phase so this runs before the theme's own handler. */
  var cardAddAt = 0;
  document.addEventListener('click', function (event) {
    var btn = event.target.closest &&
      event.target.closest('.product-item__quick-add-wrapper[data-has-variants="false"] .product-item__quick-add');
    if (!btn || btn.disabled) return;
    if (parseInt(btn.getAttribute('data-quantity-in-cart') || '0', 10) < 1) cardAddAt = Date.now();
  }, true);

  function hookCardAdds() {
    if (typeof window.on !== 'function' || typeof window.emit !== 'function') return false;
    window.on('quick-cart:updated', function () {
      if (cardAddAt && Date.now() - cardAddAt < 10000) {
        cardAddAt = 0;
        window.emit('quick-cart:open');
      }
    });
    return true;
  }
  if (!hookCardAdds()) {
    var hookTries = 0;
    var hookTimer = setInterval(function () {
      if (hookCardAdds() || ++hookTries > 50) clearInterval(hookTimer);
    }, 200);
  }
  /* Kit fence (Carlo 9/30; 03-RULES: kits are one-time only). The product-blocks wrapper of a kit carries
     data-sp-kit="true" (snippets/sp-is-kit). Right before any add-to-cart from a form inside it, drop every
     selling_plan field so the add is always one-time — even if an app or a cached form injected one.
     Capture phase, so it runs before the theme's own add handler reads the form. */
  function stripKitPlans(form) {
    if (!form || !form.closest || !form.closest('[data-sp-kit="true"]')) return;
    var plans = form.querySelectorAll('[name="selling_plan"], [name="items[][selling_plan]"]');
    for (var k = 0; k < plans.length; k++) {
      // eslint-disable-next-line no-console
      if (plans[k].value) console.warn('[sp-kit-fence] removed selling_plan from kit add-to-cart:', plans[k].value);
      plans[k].parentNode.removeChild(plans[k]);
    }
  }
  document.addEventListener('submit', function (event) { stripKitPlans(event.target); }, true);
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('button, [type="submit"]');
    if (btn) stripKitPlans(btn.form || btn.closest('form'));
  }, true);
})();
